import PocketBase, { LocalAuthStore } from 'pocketbase';

const pbUrl = import.meta.env.DEV ? 'http://127.0.0.1:8090' : '/';

const partnerPb = new PocketBase(pbUrl, new LocalAuthStore('partner_auth'));

export { partnerPb };
